{
  "long-year": "y",
  "long-year-month": "MMMM y",
  "long-year-month-day": "MMMM d, y",
  "long-year-month-day-weekday": "EEEE, MMMM d, y",
  "long-year-month-day-time": "MMMM d, y 'at' h:mm a",
  "long-year-month-day-time-timezone": "MMMM d, y 'at' h:mm a v",
  "long-month": "MMMM",
  "long-month-day": "MMMM d",
  "long-month-day-weekday": "EEEE, MMMM d",
  "long-weekday": "EEEE",
  "medium-year-month": "MMM y",
  "medium-year-month-day": "MMM d, y",
  "medium-year-month-day-weekday": "E, MMM d, y",
  "medium-year-month-day-time": "MMM d, y, h:mm a",
  "medium-year-month-day-time-timezone": "MMM d, y, h:mm a v",
  "medium-month": "MMM",
  "medium-month-day": "MMM d",
  "medium-month-day-weekday": "E, MMM d",
  "medium-month-day-time": "MMM d, h:mm a",
  "medium-month-day-time-timezone": "MMM d, h:mm a v",
  "short-year-month-day": "M/d/yy",
  "short-year-month-day-time": "M/d/yy, h:mm a",
  "short-year-month-day-time-timezone": "M/d/yy, h:mm a v",
  "short-year-month-day-time-seconds": "M/d/yy, h:mm:ss a",
  "short-year-month-day-time-seconds-timezone": "M/d/yy, h:mm:ss a v",
  "short-month-day": "M/d",
  "short-month-day-time": "M/d, h:mm a",
  "short-month-day-time-timezone": "M/d, h:mm a v",
  "short-month-day-time-seconds": "M/d, h:mm:ss a",
  "short-month-day-time-seconds-timezone": "M/d, h:mm:ss a v",
  "short-time": "h:mm a",
  "short-time-timezone": "h:mm a v",
  "short-time-seconds": "h:mm:ss a",
  "short-time-seconds-timezone": "h:mm:ss a v"
}